Converia.Core.module('Converia.Core.Icon', function() {
    return {
        cssClassPrefix: 'fe'
    };
});